import { Component, HostListener } from '@angular/core';

@Component({
    selector: 'caps-lock',
    templateUrl: `./caps-lock.component.html`
})

export class CapsLockComponent {
  capsLock = false;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(ev: KeyboardEvent) {
    this.capsLock = ev.getModifierState && ev.getModifierState('CapsLock');
  }
}